export const CURRENCIES = [
    { VALUE: 1, LABEL: 'GBP' },
    { VALUE: 2, LABEL: 'USD' },
    { VALUE: 3, LABEL: 'EUR' },
    { VALUE: 4, LABEL: 'BGN' },
];

export const CANDIDATE_SALARY_CURRENCIES = [
    { VALUE: 3, LABEL: 'EUR' },
    { VALUE: 4, LABEL: 'BGN' },
];

export const defaultCurrencyEUR = 3;

export const CURRENCIES_SIGN = [
    { VALUE: 'GBP', LABEL: '£' },
    { VALUE: 'USD', LABEL: '$' },
    { VALUE: 'EUR', LABEL: '€' },
    { VALUE: 'BGN', LABEL: 'lv' },
];

export const CURRENCY_NAMES = {
    GBP: 'GBP',
    USD: 'USD',
    EUR: 'EUR',
    BGN: 'BGN',
};
